import { ref, onMounted, onBeforeUnmount } from "vue";

export function useTypewriter(words, options = {}) {
  const {
    typingSpeed = 70,
    deletingSpeed = 35,
    pauseDuration = 2000,
  } = options;

  const displayText = ref("");
  let wordIndex = 0;
  let charIndex = 0;
  let isDeleting = false;
  let timer = null;

  const tick = () => {
    const currentWord = words[wordIndex];

    if (!isDeleting) {
      displayText.value = currentWord.slice(0, charIndex++);
    } else {
      displayText.value = currentWord.slice(0, charIndex--);
    }

    if (!isDeleting && charIndex === currentWord.length + 1) {
      setTimeout(() => {
        isDeleting = true;
      }, pauseDuration);
    }

    if (isDeleting && charIndex === 0) {
      isDeleting = false;
      wordIndex = (wordIndex + 1) % words.length;
    }

    timer = setTimeout(tick, isDeleting ? deletingSpeed : typingSpeed);
  };

  onMounted(() => {
    if (words.length) tick();
  });

  onBeforeUnmount(() => {
    clearTimeout(timer);
  });

  return { displayText };
}
